(() => {
  const main = document.getElementById('MainContent');
  const element = document.getElementById('ink-market-context');
  if (!main || !element) return;
  let context;
  try { context = JSON.parse(element.textContent); } catch { return; }
  if (context.country !== 'GB' || (!context.quantity && context.scope !== 'deals' && context.scope !== 'cart')) return;

  const numeric = String.raw`\d+(?:\.\d+)?`;
  const interval = `${numeric}(?:\\s*[–-]\\s*${numeric})?`;
  const inchUnit = String.raw`(?:inch(?:es)?|in\b|["“”″])`;
  const mm = value => String(Number((Number(value) * 25.4).toFixed(1)));
  const metricInterval = (value, factor = 1) => value.split(/\s*[–-]\s*/)
    .map(number => String(Number((Number(number) * factor).toFixed(1)))).join('–');
  const metricOnly = value => {
    if (!value || /https?:\/\//.test(value)) return value;
    let output = value
      .replace(/\b(one|two|three|four|five|six)[-\s]+inch(?:es)?\b/gi,
        (_, number) => mm({ one: 1, two: 2, three: 3, four: 4, five: 5, six: 6 }[number.toLowerCase()]) + ' mm');
    // Existing dual units are collapsed before converting any remaining inch labels.
    output = output.replace(new RegExp(`(${interval})\\s*(mm|cm)\\s*\\(\\s*${interval}\\s*${inchUnit}\\s*\\)`, 'gi'),
      (_, value, unit) => metricInterval(value, unit.toLowerCase() === 'cm' ? 10 : 1) + ' mm');
    output = output.replace(new RegExp(`(${interval})[-\\s]*${inchUnit}\\s*(?:\\(\\s*|/\\s*)${interval}\\s*(?:mm|cm)\\s*\\)?`, 'gi'),
      (_, value) => metricInterval(value, 25.4) + ' mm');
    output = output.replace(new RegExp(`(${numeric})\\s*,\\s*(${numeric})\\s*,?\\s*(and|or)\\s*(${numeric})[-\\s]*${inchUnit}`, 'gi'),
      (_, first, second, joining, last) => `${mm(first)} mm, ${mm(second)} mm ${joining} ${mm(last)} mm`);
    output = output.replace(new RegExp(`(${interval})[-\\s]*${inchUnit}`, 'gi'),
      (_, value) => metricInterval(value, 25.4) + ' mm');
    return output;
  };

  const excluded = 'script, style, textarea, input, code, pre, .ink-artwork-upload, ink-cart-artwork-preview, .jdgm-widget, [id^="judgeme"], [class*="jdgm-"], [class*="jm-"]';
  const eligible = node => !node.parentElement?.closest(excluded);
  const update = () => {
    const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!eligible(node)) continue;
      const output = metricOnly(node.nodeValue);
      if (output === node.nodeValue) continue;
      // Preserve the production value even when an option originally used its text as its value.
      const option = node.parentElement?.closest('option');
      if (option && !option.hasAttribute('value')) option.setAttribute('value', option.value);
      node.nodeValue = output;
    }
    // These four product templates split the number and inch symbol into separate nodes.
    if (context.size) main.querySelectorAll('.ig-size-number').forEach(label => {
      const unit = label.querySelector('span');
      if (!unit) return;
      const number = [...label.childNodes].find(node => node.nodeType === 3 && node.nodeValue.trim());
      const value = mm(context.size);
      if (number && number.nodeValue.trim() !== value) number.nodeValue = value;
      if (unit.textContent !== ' mm') unit.textContent = ' mm';
    });
    main.querySelectorAll('[alt], [title], [aria-label]').forEach(node => {
      if (node.closest(excluded)) return;
      for (const name of ['alt', 'title', 'aria-label']) {
        const value = node.getAttribute(name);
        const output = metricOnly(value);
        if (output !== value) node.setAttribute(name, output);
      }
    });
    const title = metricOnly(document.title);
    if (title !== document.title) document.title = title;
    main.dataset.inkGbMetric = '20261014';
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  };
  update();
  new MutationObserver(mutations => {
    if (mutations.some(mutation => eligible(mutation.target))) schedule();
  }).observe(main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['alt', 'title', 'aria-label'] });
  document.addEventListener('shopify:section:load', schedule);
})();
